import _slicedToArray from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import { AppAlertsContext } from '@infl-ts/ui-app-alerts';
import { usePageEventsTracker } from '@infl-ts/util-page-events-tracker';
import { Button } from '@mui/material';
import * as E from 'fp-ts/Either';
import { useCallback, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { onboardingCategories, statusUpdateFailure, updateOnboardingStatus } from './constants';
import { jsx as _jsx } from "react/jsx-runtime";
export var SkipOnboardingButton = function SkipOnboardingButton(_ref) {
  var onClose = _ref.onClose,
      stage = _ref.stage,
      activityState = _ref.activityState;

  var _usePageEventsTracker = usePageEventsTracker(),
      trackClick = _usePageEventsTracker.trackClick;

  var _useContext = useContext(AppAlertsContext),
      showAlert = _useContext.showAlert;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _updateOnboardingStat = updateOnboardingStatus({
    onCompleted: E.match(function () {
      return showAlert(statusUpdateFailure(t));
    }, function (_ref2) {
      var updateOnboardingStatus = _ref2.updateOnboardingStatus;

      if (updateOnboardingStatus.__typename === 'UpdateOnboardingStatusSuccess') {
        var _stage$position, _stage$name;

        trackClick('Skip for now', onboardingCategories.challenge, "Stage ".concat(((_stage$position = stage === null || stage === void 0 ? void 0 : stage.position) !== null && _stage$position !== void 0 ? _stage$position : 0) + 1, ": ").concat((_stage$name = stage === null || stage === void 0 ? void 0 : stage.name) !== null && _stage$name !== void 0 ? _stage$name : ''));
      } else {
        showAlert(statusUpdateFailure(t));
      }
    })
  }),
      _updateOnboardingStat2 = _slicedToArray(_updateOnboardingStat, 1),
      updateStatus = _updateOnboardingStat2[0];

  var skipOnboarding = useCallback(function () {
    return void updateStatus({
      variables: {
        input: {
          status: 'SKIPPED'
        }
      }
    });
  }, [updateStatus]);
  var onClick = useCallback(function () {
    skipOnboarding();
    onClose();
  }, [onClose]);
  return activityState === 'closed' ? null : /*#__PURE__*/_jsx(Button, {
    sx: {
      color: function color(t) {
        return t.palette.neutral.main;
      }
    },
    variant: "text",
    onClick: onClick,
    children: t('Skip Onboarding')
  });
};